module.exports = __webpack_public_path__ + "img/progressicowhite.f90c3928.png";